import axios from "axios";

export const API = axios.create({ baseURL: "https://invoicing-api.intellect-academy.co" });
// export const API = axios.create({ baseURL: "http://localhost:5000" });
//
API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }

  return req;
});

// export const fetchInvoices =() => API.get('/invoices')
export const createPayment = (payment) => API.post(`/payment`, payment);
export const createCheckPayment = (payment) =>
  API.post(`/payment/check`, payment);
export const updateCheckPayment = (payment) =>
  API.post(`/payment/update_check`, payment);
export const updatePayment = (payment, id) =>
  API.put(`/payment/update_payment/` + id, payment);
export const getPayment = (id) => API.get(`/payment/` + id);

export const fetchInvoice = (id) => API.get(`/invoices/${id}`);
export const fetchInvoicesByClient = (id) =>
  API.get(`/invoices/get-by-clientId/${id}`);
export const addInvoice = (invoice) => API.post("/invoices", invoice);
export const updateInvoice = (id, updatedInvoice) =>
  API.patch(`/invoices/${id}`, updatedInvoice);
export const deleteInvoice = (id) => API.delete(`/invoices/${id}`);
export const fetchInvoicesByUser = ({ search, role, page, limit }) =>
  API.get(
    `/invoices?searchQuery=${search}&&role=${role}&page=${page}&limit=${limit}`
  );
export const fetchInvoicesByProduct = (searchQuery, itemId) =>
  API.post("/invoices/get-by-productId/", {
    itemId,
    search: searchQuery.search,
  });

export const fetchPartialAndNoPaidInvoices = (id, query = {}) => {
  const params = new URLSearchParams({
    page: query.page || 1,
    limit: query.limit || 10,
  });
  if (query.search) params.append("search", query.search);
  if (query.itemId) params.append("itemId", query.itemId);

  return API.get(`/invoices/get-rest/${id}?${params.toString()}`);
};

export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient = (client) => API.post("/clients", client);
export const updateClient = (id, updatedClient) =>
  API.patch(`/clients/${id}`, updatedClient);
export const deleteClient = (id) => API.delete(`/clients/${id}`);
export const fetchClientsByUser = (searchQuery) =>
  API.get(
    `/clients/user?searchQuery=${searchQuery.userId}&search=${searchQuery.search}&page=${searchQuery.page}&pageSize=${searchQuery.pageSize}`
  );

export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgot = (formData) => API.post("/users/forgot", formData);
export const reset = (formData) => API.post("/users/reset", formData);

export const fetchProfilesBySearch = (searchQuery) =>
  API.get(
    `/profiles/search?searchQuery=${
      searchQuery.search || searchQuery.year || "none"
    }`
  );
export const fetchProfile = (id) => API.get(`/profiles/${id}`);
export const fetchProfiles = () => API.get("/profiles");
export const fetchProfilesByUser = (searchQuery) =>
  API.get(`/profiles?searchQuery=${searchQuery.search}`);
export const createProfile = (newProfile) => API.post("/profiles", newProfile);
export const updateProfile = (id, updatedProfile) =>
  API.patch(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.delete(`/profiles/${id}`);

//products
export const fetchProduct = (id) => API.get(`/products/${id}`);
export const fetchProducts = (page) => API.get(`/products?page=${page}`);
export const addProduct = (product) => API.post("/products", product);
export const updateProduct = (id, updatedProduct) =>
  API.patch(`/products/${id}`, updatedProduct);
export const deleteProduct = (id) => API.delete(`/products/${id}`);
export const fetchProductsByUser = (searchQuery) =>
  API.get(
    `/products/user?searchQuery=${searchQuery.search}&archived=${searchQuery.archived}`
  );

// assistants

export const addAssistant = (assistant) => API.post("/users/create", assistant);
export const updateAssistant = (id, updatedAssistant) =>
  API.patch(`/users/${id}`, updatedAssistant);
export const deleteAssistant = (id) => API.delete(`/users/${id}`);
export const fetchAssistantsByUser = (searchQuery) =>
  API.get(`/users/user?searchQuery=${searchQuery.search}`);
export const fetchXlData = () => API.get("clientXl");

//bank

export const fetchBank = (id) => API.get(`/bank/${id}`);
export const fetchBanks = () => API.get(`/bank`);
export const addBank = (bank) => API.post("/bank", bank);
export const deleteBank = (id) => API.delete(`/bank/${id}`);

//checks
export const fetchChecks = (searchQuery) =>
  API.get(
    `/check?page=${searchQuery?.page}&from=${searchQuery.from}&to=${searchQuery.to}&holderName=${searchQuery.holderName}`
  );

export const fetchExistingChecks = () => API.post(`/check/existing-checks`);

export const downloadPdfChecks = (data) => API.post("/create-pdf-checks", data);
export const fetchPdfChecks = () =>
  API.get("/fetch-pdf-checks", {
    responseType: "blob",
  });
export const updateChecks = (data) => API.post("/check", data);
// billing cycle

export const getBillingCycle = (user) => API.get("/billing-cycle?user=" + user);
export const getBillingCycleByAssistant = (assistant) =>
  API.post("/billing-cycle/get_by_assistant", assistant);
export const createBillingCycle = (data) => API.post("/billing-cycle", data);
export const getDailyPayments = (id) => API.get("/billing-cycle/" + id);
export const getOneBillingCycle = (id) =>
  API.get("/billing-cycle/get_by_id/" + id);
export const checkBillingCycle = (id) => API.post("/billing-cycle/check", id);
// account receivables

export const getAccountReceivables = () => API.get("/account-receivables");
export const createAccountReceivables = (data) =>
  API.post("/account-receivables", data);
